import { useFlag } from '@unleash/proxy-client-react';
import { Navigate } from 'react-router-dom';

const withSysUtilsFeatureFlagCheck =
  // eslint-disable-next-line react/display-name
  (Component: React.FC) => (props: Record<string, unknown>) => {
    const isSystemUtilsEnabled = useFlag('SystemUtils');
    if (!isSystemUtilsEnabled) {
      return <Navigate to="/" replace />;
    }
    return <Component {...props} />;
  };

export default withSysUtilsFeatureFlagCheck;
